import { render, staticRenderFns } from "./TheTeam.vue?vue&type=template&id=e70ad8fa&"
import script from "./TheTeam.vue?vue&type=script&lang=js&"
export * from "./TheTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports